import React from "react";
import { FaFacebook, FaLinkedin } from "react-icons/fa";
import { AiFillInstagram } from "react-icons/ai";
import { HiMenuAlt1 } from "react-icons/hi";
import { BsThreadsFill } from "react-icons/bs";

const Footer = () => {
  return (
    <footer className="bg-[#1d3557] text-white pb-12 pt-40">
      <div className="container mx-auto px-[10%]">
        {/* Logo and Tagline */}
        <div className="flex items-start space-x-6 mb-14">
          <img
            src="/Assets/sc-logo.jpg"
            alt="Consultants Logo"
            className="w-40 rounded-full"
          />
          <div>
            <h2 className="text-white text-[45px] font-semibold leading-[50px] tracking-tight">
              REACH FOR YOUR DREAMS.
              <br />
              <span className="text-[#457b9d]">CREATE YOUR Future.</span>
            </h2>
          </div>
        </div>

        <div className="flex flex-wrap justify-between items-start">
          {/* Main Links */}
          <div>
            <h3 className="text-gray-400 mb-4 text-[20px] font-semibold">
              SocraticAli Consultants
            </h3>
            <ul className="space-y-2 text-[20px] font-semibold">
              <li>
                <a href="#home" className="font-semibold">
                  Home
                </a>
              </li>
              {/* <li><a >About</a></li> */}
              {/* <li><a >Agents</a></li>
                        <li><a >Value-Added Services</a></li>
                        <li><a >Blog</a></li> */}
            </ul>
          </div>

          {/* Business Setup */}

          {/* Info */}
          <div>
            <h3 className="text-gray-400 mb-4 text-[20px] font-semibold">
              Info
            </h3>
            <ul className="space-y-2 text-[20px] font-semibold">
              {/* <li>
                <a >Privacy Policy</a>
              </li>
              <li>
                <a >Terms & Conditions</a>
              </li> */}
              <li>
                <a href="#contact-us">Contact</a>
              </li>
            </ul>
          </div>

          {/* Socials */}
          <div>
            <h3 className="text-gray-400 mb-4 text-[20px] font-semibold mr-40">
              Socials
            </h3>
            {/* Social Media Icons */}
            <div className="flex space-x-4 mt-4">
              <a
                href="https://www.facebook.com/socraticaliconsultants"
                target="_blank"
                rel="noopener noreferrer"
                className="icon text-white"
              >
                <FaFacebook className="size-5 text-white" />
              </a>
              <a
                href="https://www.instagram.com/socratic.ali.consultants?igsh=c2JjZXdubGQxdWVs"
                target="_blank"
                rel="noopener noreferrer"
                className="icon text-white"
              >
                <AiFillInstagram className="size-6 text-white" />
              </a>
              <a
                href="https://www.threads.net/@socratic.ali.consultants"
                target="_blank"
                rel="noopener noreferrer"
                className="icon text-white"
              >
                <BsThreadsFill className="size-5 text-white" />
              </a>
              <a
                href="https://www.linkedin.com/company/socraticali-consultants/ "
                target="_blank"
                rel="noopener noreferrer"
                className="icon text-white"
              >
                <FaLinkedin className="size-5 text-white" />
              </a>
            </div>
          </div>

          {/* Address */}
          <div>
            <a
              href="https://maps.app.goo.gl/bMsMhGuraGsFpncR7?g_st=aw"
              target="_blank"
              rel="noopener noreferrer"
            >
              <h3 className="text-gray-400 mb-4 text-[20px] font-semibold">
                Address
              </h3>
              <p className="text-[20px] font-semibold">
                MCB Building, 4th Floor,
              </p>
              <p className="text-[20px] font-semibold">B Block,</p>
              <p className="text-[20px] font-semibold">
                Coorperative Housing <br /> Society,
              </p>
              <p className="text-[20px] font-semibold">Lahore, Pakistan</p>
            </a>
          </div>
        </div>

        {/* Bottom Copyright Section */}
        <div className="mt-10 border-t border-gray-700 pt-10 text-center text-[16px]">
          <p>
            Copyright © 2025 SocraticAli Consultants. All rights reserved. | Website by{" "}
            <a
              href="https://meldindigitalagency.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#457b9d]"
            >
              Meldin Digital Agency
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
